import { REGION_CURRENCY_LIST } from '@dragonfruit/constants/price';
import { formatPriceWithCurrency } from '@dragonfruit/utils/priceParser';
import * as loadingState from '../constants/loadingState';

export const FETCH_PURCHASE_HISTORY = 'FETCH_PURCHASE_HISTORY';
export const FETCH_PURCHASE_HISTORY_SUCCESS = 'FETCH_PURCHASE_HISTORY_SUCCESS';
export const FETCH_PURCHASE_HISTORY_ERROR = 'FETCH_PURCHASE_HISTORY_ERROR';

export const fetchPurchaseHistory = () => ({
  type: FETCH_PURCHASE_HISTORY,
});

export const fetchPurchaseHistoryError = errorCode => ({
  type: FETCH_PURCHASE_HISTORY_ERROR,
  payload: {
    errorCode,
  },
});

export const fetchPurchaseHistorySuccess = ({
  currentPlanList,
  historyList,
}) => ({
  type: FETCH_PURCHASE_HISTORY_SUCCESS,
  payload: {
    currentPlanList,
    historyList,
  },
});

const INIT_STATE = {
  currentPlanList: [],
  historyList: [],
  loadingState: loadingState.EMPTY,
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_PURCHASE_HISTORY:
      return {
        ...state,
        loadingState: loadingState.LOADING,
      };
    case FETCH_PURCHASE_HISTORY_SUCCESS:
      return {
        ...state,
        loadingState: loadingState.READY,
        currentPlanList: action.payload.currentPlanList,
        historyList: action.payload.historyList,
      };
    case FETCH_PURCHASE_HISTORY_ERROR:
      return {
        ...state,
        loadingState: loadingState.ERROR,
      };
    default:
      return state;
  }
};

export default reducer;

export function transformHistoryData(rawData, region) {
  const {
    price: originalPrice,
    paymentAmount: sellPrice,
    displayCurrency,
  } = rawData;

  const currency = REGION_CURRENCY_LIST[region];
  const discountAmount = originalPrice - sellPrice;

  return {
    ...rawData,
    displayOriginalPrice: formatPriceWithCurrency(
      currency,
      displayCurrency,
      originalPrice
    ),
    displaySellPrice: formatPriceWithCurrency(
      currency,
      displayCurrency,
      sellPrice
    ),
    discountAmount,
    displayDiscountAmount: `- ${formatPriceWithCurrency(
      currency,
      displayCurrency,
      discountAmount
    )}`,
  };
}



// WEBPACK FOOTER //
// ./app/redux/purchaseHistory.js